import Vue         from 'vue'
import store       from './store/index'
import App         from './App'
import Router      from './router/router'
import dayjs       from 'dayjs'
import localForage from 'localforage'

localForage.config({
  driver: [localForage.INDEXEDDB, localForage.WEBSQL, localForage.LOCALSTORAGE],
  name: 'unmineable'
})

var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)

Vue.config.productionTip = false

Vue.filter('toMinutes', function (value) {
  return dayjs(value).minute()
});

Vue.filter('fromNow', function (value) {
  return dayjs().to(dayjs(value))
});

Vue.filter('formatDateSecond', function (value) {
  return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
});

Vue.filter('formatFullDate', function (value) {
  return dayjs(value).format('YYYY-MM-DD HH:mm')
});

Vue.filter('capitalize', function (value) {
  return value.substring(0, 1).toUpperCase() + value.substring(1, value.length)
});

Vue.filter('uppercase', function (value) {
  return value.toUpperCase()
});

// Vue.filter('twoDecimals', function (value) {
//   return value.toFixed(2);
// });

Vue.filter('thousandComma', function (value) {
  var b = false
  var calculateFixed = 0
  value = value || 0
  value = value + ''

  if (value.indexOf('.') === -1) {
    b = true
  } else {
    calculateFixed = value.split('.')[1].length
  }

  value = value.toString()
  value = parseFloat(value).toFixed(calculateFixed);

  var fNumber = 0

  if (value.split('.')[0] !== '0') {
    fNumber = value.split('.')[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  if (b === true) {
    return fNumber
  } else {
    return fNumber + '.' + value.split('.')[1]
  }
});

Vue.directive('clickaway', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
});

/* eslint-disable no-new */

window.dayjs  = dayjs
window.lf = localForage

const migrateLocalStorage = async () => {
  await store.restored
  // testing
  // store.dispatch('setLastNewsDate', 1709585944361)
}

migrateLocalStorage().then(() => {
  new Vue({
    el        : '#app',
    router    : Router,
    store,
    template  : '<App/>',
    components: { App }
  })
})




// WEBPACK FOOTER //
// ./src/main.js